<template>
    <div class="tile is-ancestor">
        <div class="tile is-vertical is-parent">
            <div class="tile is-child has-text-left">
                <h1 class="title">Sign Up</h1>
                <h2 class="subtitle">Create a new account</h2>
            </div>

            <div class="tile is-child has-text-left">
                <h3 style="margin-bottom:0px" class="subtitle is-5">My Details</h3>
                <p class="is-italic">Passwords should be 8 or more characters and should contain at least 1 uppercase letter, 1 lowercase letter, a number and a symbol (!£$%@?) e.g. Abcd1234&</p>
            </div>

            <div class="tile is-child">                
                <section>
                    <form @submit.prevent="validateBeforeSubmit">
                        <div class="tile is-ancestor box has-background-white-ter has-text-left">
                            <div class="tile is-parent">
                                <div class="tile is-child ">
                                    <b-field label="First name"
                                        :type="{'is-danger': errors.has('first_name')}"
                                        :message="errors.first('first_name')">
                                        <b-input v-model="user.first_name" name="first_name" v-validate="'required'" />
                                    </b-field>

                                    <b-field label="Last name"
                                        :type="{'is-danger': errors.has('last_name')}"
                                        :message="errors.first('last_name')">
                                        <b-input v-model="user.last_name" name="last_name" v-validate="'required'" />
                                    </b-field>

                                    <b-field label="Email"
                                        :type="{'is-danger': errors.has('email')}"
                                        :message="errors.first('email')">
                                        <b-input type="email" v-model="user.email" name="email" v-validate="'required'" />
                                    </b-field>
                                </div>
                            </div>
                            <div class="tile is-parent">
                                <div class="tile is-child">
                                    <!-- <b-field label="Username"
                                        :type="{'is-danger': errors.has('username')}"
                                        :message="errors.first('username')">
                                        <b-input type="text" v-model="username" name="username" v-validate="'required|alpha'" />
                                    </b-field> -->

                                    <b-field label="Password"
                                        :type="{'is-danger': errors.has('password')}"
                                        :message="errors.first('password')">
                                        <b-input type="password" v-model="user.password1" name="password" v-validate="'required|min:8'" />
                                    </b-field>

                                    <b-field label="Confirm password"
                                        :type="{'is-danger': errors.has('confirm-password')}"
                                        :message="[{
                                            'The confirm password field is required' : errors.firstByRule('confirm-password', 'required'),
                                            'The confirm password is not valid' : errors.firstByRule('confirm-password', 'is')
                                        }]">
                                        <b-input type="password" v-model="user.password2" name="confirm-password"
                                            v-validate="{ required: true, is: user.password1 }" />
                                    </b-field>
                                </div>
                            </div>
                        </div>

                        <div class="tile is-ancestor" style="margin-top:30px">
                            <div class="tile is-vertical is-parent">
                                <div class="tile is-child">
                                    <button type="submit" class="button is-primary is-large is-pulled-right"> Submit </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
            <!-- <div class="tile is-child box">
                <p class="title">Two</p>
            </div> -->
        </div>
    </div>
            
</template>

<script>
import MemberCondition from "../modals/MemberCondition"
export default {
    name: 'SignupComponent',
    data: function(){
        return {
            user: {}
        }
    },
    components: {
        MemberCondition
    },
    methods: {
        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                console.log('result', result)
                if (result) {
                    this.$emit("signup", this.user)
                }
                else {
                    this.$toast.open({
                        message: 'Form is not valid! Please check the fields.',
                        type: 'is-danger',
                        position: 'is-top'
                    })
                }
            });
        },
        termsConditionModal() {
            this.$modal.open({
                parent: this,
                component: MemberCondition,
                hasModalCard: true,
                props: {
                }
            })
        }
    }
    
}
</script>

